module.exports = __webpack_public_path__ + "img/DTIO4.d6ca077d.png";